import axios from "axios";
import Config from "../../config/config";

const todosProdutos = () => {
    return axios({
        method: "post",
        url: "https://api.katuxa.com.br/api/v1/apps/pdv/produtos"
    });
};

export default todosProdutos;
